import React from 'react';
import PropTypes from 'prop-types';
import { videoShape } from '../../utils/shapes';
import VideoListItem from '../VideoListItem';
import './VideoList.css';

function VideoList({ videos, onVideoClick, nowPlayingVideo }) {
  return (
    <div className="video-list">
      <h2 className="title">Recent Uploads</h2>
      <ul>
        {videos.map(video => (
          <VideoListItem
            key={video.id.videoId}
            video={video}
            onVideoClick={onVideoClick}
            nowPlaying={nowPlayingVideo.id.videoId === video.id.videoId}
          />
        ))}
      </ul>
    </div>
  );
}

VideoList.propTypes = {
  videos: PropTypes.arrayOf(videoShape),
  onVideoClick: PropTypes.func,
  nowPlayingVideo: videoShape
};

export default VideoList;



// WEBPACK FOOTER //
// ./src/components/VideoList/index.js